export default "__VITE_ASSET__157641dd__"